import { inject, Injectable } from '@angular/core';
import { UserService } from '@app/user';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { BehaviorSubject } from 'rxjs';
import { NavMenuItem } from '../models/nav-menu-item';
import { navItemsAccessFilter } from '../../utils';

@Injectable({
    providedIn: 'root',
})
export class LearnNavItemsService {
    private readonly userService = inject(UserService);

    readonly learnItems$ = new BehaviorSubject<NavMenuItem[]>([
        {
            name: marker('v3-header-menu-item-my-learning-progress'),
            icon: 'chart',
            route: ['/profile', 'me'],
            access: (user) => !user.company.trial,
        },
        {
            name: marker('v3-header-menu-item-my-achievements'),
            icon: 'certificate',
            route: ['/achievements'],
            access: () => true,
        },
        {
            name: marker('v3-header-menu-item-my-saved-content'),
            icon: 'bookmark',
            route: ['/explore', 'my-learning', 'saved'],
            access: () => true,
        },
        {
            name: marker('v3-header-menu-item-recommended-to-me'),
            icon: 'recommend',
            route: ['/explore', 'my-learning', 'recommended'],
            access: (user) => !user.company.trial,
        },
        {
            name: marker('v3-header-menu-item-recently-watched'),
            icon: 'clock-arrow',
            route: ['/explore', 'my-learning', 'history'],
            access: (user) => !user.company.trial,
        },
        {
            name: marker('v3-header-menu-item-challenges'),
            icon: 'graduate-cap',
            route: ['/challenge', 'exam'],
            access: () => true,
        },
        {
            name: marker('v3-header-menu-my-programme'),
            icon: 'program',
            route: [],
            access: (user) => user.program.enabled,
        },
    ]).pipe(navItemsAccessFilter(this.userService));
}
